import React from 'react';
import {
  Box,
  Text,
  Heading,
  Badge,
  CheckCircleIcon,
  MailIcon,
  GlobeIcon,
} from '@razorpay/blade/components';
import { ACTION_ICONS } from '../../constants';
import { SelectionCard } from './styles';
import { ActionSelectionProps } from './types';

const ActionSelection = ({ groupedActions, selectedActionCode, onSelect }: ActionSelectionProps) => {
  const getIcon = (code: string, isComingSoon?: boolean) => {
    const iconColor = isComingSoon ? 'surface.icon.gray.muted' : 'interactive.icon.primary.normal';
    switch (code) {
      case 'approve_or_reject':
        return <CheckCircleIcon size="medium" color={isComingSoon ? 'surface.icon.gray.muted' : 'feedback.icon.positive.intense'} />;
      case 'send_email':
        return <MailIcon size="medium" color={iconColor} />;
      case 'call_api':
        return <GlobeIcon size="medium" color={iconColor} />;
      case 'send_to_whatsapp':
        return <Text size="medium">💬</Text>;
      case 'send_to_slack':
        return <Text size="medium">📱</Text>;
      case 'add_to_excel':
        return <Text size="medium">📊</Text>;
      case 'connect_to_n8n':
        return <Text size="medium">🔗</Text>;
      default:
        return <Text size="medium">{ACTION_ICONS[code] || '⚡'}</Text>;
    }
  };

  const groups = Object.keys(groupedActions).sort((a, b) => {
    if (a === 'Coming Soon') return 1;
    if (b === 'Coming Soon') return -1;
    return 0;
  });

  return (
    <Box display="flex" flexDirection="column" gap="spacing.5">
      <Box>
        <Heading size="medium">Choose a step</Heading>
        <Text size="small" color="surface.text.gray.muted" marginTop="spacing.2">
          Select an action to add to your workflow
        </Text>
      </Box>

      {groups.map((group) => (
        <Box key={group} display="flex" flexDirection="column" gap="spacing.3">
          <Text size="small" color="surface.text.gray.muted" weight="semibold">
            {group}
          </Text>
          <Box display="flex" flexDirection="column" gap="spacing.2">
            {groupedActions[group].map((action) => {
              const isComingSoon = action.is_coming_soon === true;
              return (
                <SelectionCard
                  key={action.code}
                  isSelected={!isComingSoon && selectedActionCode === action.code}
                  isDisabled={isComingSoon}
                  onClick={() => !isComingSoon && onSelect(action)}>
                  <Box display="flex" alignItems="center" justifyContent="space-between">
                    <Box display="flex" alignItems="center" gap="spacing.3">
                      {getIcon(action.code, isComingSoon)}
                      <Text 
                        weight="medium" 
                        color={isComingSoon ? 'surface.text.gray.muted' : undefined}>
                        {action.name}
                      </Text>
                    </Box>
                    {isComingSoon && (
                      <Badge size="small" color="neutral">
                        Coming Soon
                      </Badge>
                    )}
                  </Box>
                </SelectionCard>
              );
            })}
          </Box>
        </Box>
      ))}
    </Box>
  );
};

export { ActionSelection };
